import React, { useState } from "react";
import { ArrowRight, Shield, Zap, Target } from "lucide-react";
import DemoRequestModal from "./DemoRequestModal";

const Hero = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const handleWatchVideo = () => {
    document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <section className="relative bg-gradient-to-br from-slate-50 to-blue-50 py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-6">
              <Zap size={16} className="mr-2" />
              AI-Powered Security Intelligence
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-4 leading-tight">
              Your Security Engineer,
              <span className="text-blue-600 block">Reimagined</span>
            </h1>
            
            <p className="text-2xl lg:text-3xl font-semibold text-gray-700 mb-6">
              Transform How You Track, Prioritize, and Remediate Vulnerabilities
            </p>

            {/* Subheadline */}
            <p className="text-lg lg:text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            Self-learning AI that thinks like your best engineer. Unifies findings from every tool, prioritizes by real risk, and autonomously patches vulnerabilities — so you can focus on what matters, not manual triage.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
              <button 
                onClick={() => setIsDemoModalOpen(true)}
                className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg rounded-md font-medium transition-all duration-200 transform hover:scale-105"
              >
                Request Demo
                <ArrowRight size={20} className="ml-2" />
              </button>
              {/* <button 
                className="inline-flex items-center justify-center border border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-4 text-lg rounded-md font-medium transition-all duration-200"
                onClick={handleWatchVideo}
              >
                Watch Video
              </button> */}
            </div>

          {/* Key Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="flex justify-center mb-3">
                <Zap className="w-8 h-8 text-purple-600" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">10x</div>
              <div className="text-gray-600">Faster Remediation</div>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-3">
                <Shield className="w-8 h-8 text-blue-600" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">90%</div>
              <div className="text-gray-600">Reduction in Alert Fatigue</div>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-3">
                <Target className="w-8 h-8 text-green-600" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">100%</div>
              <div className="text-gray-600">Vulnerability Accountability</div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
        <div className="absolute top-20 left-10 w-20 h-20 bg-blue-200 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute top-40 right-20 w-16 h-16 bg-purple-200 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-green-200 rounded-full opacity-20 animate-pulse"></div>
      </div>
    </section>

    {/* Demo Request Modal */}
    <DemoRequestModal 
      isOpen={isDemoModalOpen} 
      onClose={() => setIsDemoModalOpen(false)} 
    />
    </>
  );
};

export default Hero;